import React from 'react';
import JoinCard from './joinCard';

const Join = () => {
  const plans = [
    {
      planName: 'Family Package',
      price: '$9',
      description: 'Best for personal use cases.',
      features: ['5 Users', 'Basic Features', 'Lifetime Access', 'Basic Support'],
      isPopular: false,
      buttonText: 'Choose Family'
    },
    {
      planName: 'School Package',
      price: '$19',
      description: 'Best for growing teams.',
      features: ['20 Users', 'Advanced Features', 'Lifetime Access', 'Premium Support'],
      isPopular: true,
      buttonText: 'Choose School'
    },
    {
      planName: 'District',
      price: '$30',
      description: 'Best schools.',
      features: ['Unlimited Users', 'All Features', 'Lifetime Access', '24/7 Support'],
      isPopular: false,
      buttonText: 'Choose District'
    }
  ];

  return (
    <div id="jo" className="flex flex-col justify-center items-center min-h-screen bg-gray-50 p-4">
      <h1 className="text-4xl font-bold mb-0">Choose Your Plan</h1>
      <p className="text-gray-600 mb-5">Flexible plans for efficient learning.</p>
      
      {/* Grid Layout for Cards */}
      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {plans.map((plan) => (
          <JoinCard key={plan.planName} {...plan} />
        ))}
      </div>
    </div>
  );
};

export default Join;